import { FC, useEffect } from 'react';

import { Button, Form, Label, Select, Typography, message } from 'ui';
import Input from 'ui/input/input';
import { formRules } from 'utils/formRules';

import { useCreateReferrerLinkMutation } from 'services/promoter/promoterApiService';
import { useLazyGetCurrentUserQuery } from 'services/user-management/userManagementApiService';

import s from './ReferralLink.module.scss';

const ReferralLink: FC = () => {
  const [getCurrentUser, { data: currentUser, isFetching: userFetching }] =
    useLazyGetCurrentUserQuery();

  const [CreateReferrerLink, { isLoading: isSending }] = useCreateReferrerLinkMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  useEffect(() => {
    if (currentUser?.promoters?.length) {
      form.setFieldValue('promoterId', {
        value: currentUser?.promoters[0].promoterId,
        label: currentUser?.promoters[0].name,
      });
    }
  }, [currentUser, form]);

  const handleSubmit = async (values) => {
    const payload = {
      email: values.email,
      promoterId: values.promoterId.value,
      referrerLink: values.referrerLink,
    };
    const res = await CreateReferrerLink(payload);

    if ('data' in res) {
      message.success('Refferal link submitted');
      form.resetFields();
    }
  };
  return (
    <div className={s.wrapper}>
      <Typography type="h2" weight={700}>
        Referral links
      </Typography>
      <Form className={s.form} onFinish={(values) => handleSubmit(values)} form={form}>
        <div>
          <Label>Promoter</Label>
          <Form.Item name="promoterId" rules={[formRules.required]}>
            <Select
              isLoading={userFetching}
              placeholder="Choose account which referrer link will be associated to"
              options={currentUser?.promoters?.map((promoter) => ({
                label: promoter.name,
                value: promoter.promoterId,
              }))}
            />
          </Form.Item>
        </div>
        <div className={s.emailWrapper}>
          <div className={s.itemWrapper}>
            <Label>E-mail</Label>
            <Form.Item name="email" validateFirst rules={[formRules.required, formRules.email]}>
              <Input name="email" autoComplete="off" />
            </Form.Item>
          </div>
          <div className={s.itemWrapper}>
            <Label>Referral Link</Label>
            <Form.Item
              name="referrerLink"
              validateFirst
              rules={[formRules.required, formRules.referrerLink]}>
              <Input name="referrerLink" autoComplete="off" />
            </Form.Item>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, width: '100%' }}>
          <Button loading={isSending} htmlType="submit" block size="large">
            SUBMIT
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ReferralLink;
